import { IVumUserVehicleRelation, IVumUserVehicleRelationUpdate } from './VumClient';
import { CommissionIdConverter } from './CommissionIdConverter';
import { DevicePlatform, EnrollmentStatus, Role } from '../enums';

export interface IVumFlattenedVehicleForUpdate {
    bid?: string
    commissionNumber?: string
    commissionNumberYear?: string
    vin?: string
    nickname?: string
    licensePlateNumber?: string
}

export interface IVumFlattenedVehicle {
    bid?: string
    commissionNumber?: string
    commissionNumberYear?: string
    vin?: string
    nickname?: string
    licensePlateNumber?: string
    role: Role
    enrollmentStatus: EnrollmentStatus
    devicePlatform: DevicePlatform
    primaryCar: boolean
    dealerId?: string
    dealerBrandCode?: string
    allocatedDealerCountry?: string
    preferredContact?: string
}

export class VumFlattenedVehicleConverter {

    public static convertUserVehicleRelationToFlattenedVehicle(relation: IVumUserVehicleRelation): IVumFlattenedVehicle {
        return {
            vin: relation.vehicle?.vin,
            ...CommissionIdConverter.convertCommissionIdToData(relation.vehicle?.commissionId),
            nickname: relation.vehicleNickname,
            licensePlateNumber: relation.licensePlate,
            primaryCar: !!relation.primaryCar,
            dealerId: relation.dealerId,
            dealerBrandCode: relation.dealerBrandCode,
            allocatedDealerCountry: relation.allocatedDealerCountry,
            preferredContact: relation.preferredContact,
            role: Role[relation.role as keyof typeof Role] ?? Role.UNKNOWN,
            enrollmentStatus: EnrollmentStatus[relation.enrollmentStatus as keyof typeof EnrollmentStatus] ?? EnrollmentStatus.UNKNOWN,
            devicePlatform: DevicePlatform[relation.vehicle?.modBackend as keyof typeof DevicePlatform] ?? DevicePlatform.UNKNOWN
        };
    }

    public static convertUserVehicleRelationsToFlattenedVehicles(relations: IVumUserVehicleRelation[]): IVumFlattenedVehicle[] {
        const vehicles: IVumFlattenedVehicle[] = [];
        relations.forEach(relation => {
            vehicles.push(this.convertUserVehicleRelationToFlattenedVehicle(relation));
        });
        return vehicles;
    }

    public static convertFlattenedVehicleToUserVehicleRelation(vehicle: IVumFlattenedVehicleForUpdate): IVumUserVehicleRelationUpdate {
        const commissionId = CommissionIdConverter.convertCommissionDataToId(vehicle.commissionNumber, vehicle.bid, vehicle.commissionNumberYear);
        return {
            vehicleNickname: vehicle.nickname,
            licensePlate: vehicle.licensePlateNumber,
            vehicle: {
                vin: vehicle.vin,
                commissionId,
            }
        };
    }
}